
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/tasks/list",
      function () {
        return require("private-next-pages/tasks/list.tsx");
      }
    ]);
  